import { Building2, Coins, Percent, ArrowUpRight, FileDown, MapPin, Globe, Mail, Phone } from "lucide-react";
import { Chapter, Body } from "@/components/Chapter";
import { FinTable } from "@/components/FinTable";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RISK_ICONS = [Building2, Coins, Percent];

export const Cierre = ({ d }) => (
  <>
    <Chapter id="17" num="17" title="Estructura Legal">
      <FinTable testid="tabla-legal" columns={["Concepto", "Detalle"]} rows={d.legal} rightFrom={2} />
    </Chapter>

    <Chapter id="18" num="18" title="Factores de Riesgo">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {d.riesgos.map((r, i) => {
          const Icon = RISK_ICONS[i % RISK_ICONS.length];
          return (
            <div key={r.riesgo} data-testid={`riesgo-card-${i}`} className="flex flex-col rounded-sm border border-sand bg-white/85 p-6 transition-colors duration-300 hover:border-gold/60">
              <Icon className="h-5 w-5 text-gold" />
              <p className="mt-3 font-serif text-lg text-jade">{r.riesgo}</p>
              <p className="mt-2 text-xs leading-relaxed text-graphite/65">{r.descripcion}</p>
              <div className="mt-4 border-t border-sand/70 pt-3">
                <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-gold">Mitigación</p>
                <p className="mt-1.5 text-xs leading-relaxed text-graphite/70">{r.mitigacion}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Chapter>

    <Chapter id="19" num="19" title="Contacto">
      <div data-testid="contacto-panel" className="relative overflow-hidden rounded-sm bg-jade px-7 py-12 sm:px-12 sm:py-16">
        <div className="absolute -right-16 -top-16 h-56 w-56 rotate-45 border border-gold/25" />
        <div className="absolute -bottom-20 -right-8 h-56 w-56 rotate-45 border border-gold/15" />
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Inversión en Lombok</p>
        <h3 className="mt-4 max-w-xl font-serif text-3xl font-light leading-tight text-ivory sm:text-4xl">
          Hablemos de su inversión en <span className="italic text-gold">Lombok</span>
        </h3>
        <div className="mt-8 flex flex-col gap-3 text-sm text-ivory/85 sm:flex-row sm:flex-wrap sm:gap-x-10">
          <span className="inline-flex items-center gap-2">
            <Globe className="h-4 w-4 text-gold" />
            <a data-testid="contacto-web" href={`https://${d.contacto.web}`} target="_blank" rel="noopener noreferrer" className="underline decoration-gold/60 underline-offset-4 transition-colors hover:text-gold">
              {d.contacto.web}
            </a>
          </span>
          <span className="inline-flex items-center gap-2">
            <Mail className="h-4 w-4 text-gold" />
            <a data-testid="contacto-email" href={`mailto:${d.contacto.email}`} className="underline decoration-gold/60 underline-offset-4 transition-colors hover:text-gold">
              {d.contacto.email}
            </a>
          </span>
          <span className="inline-flex items-center gap-2">
            <Phone className="h-4 w-4 text-gold" />
            <a data-testid="contacto-phone" href={`tel:${d.contacto.telefono.replace(/\s/g, "")}`} className="transition-colors hover:text-gold">
              {d.contacto.telefono}
            </a>
          </span>
          <span className="inline-flex items-center gap-2">
            <MapPin className="h-4 w-4 text-gold" />
            {d.contacto.ubicacion}
          </span>
        </div>
        <div className="mt-10 flex flex-wrap gap-4">
          <a
            data-testid="pdf-download-btn-contact"
            href={`${API}/dossier/pdf`}
            className="inline-flex items-center gap-2 bg-gold px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-graphite transition-colors duration-300 hover:bg-ivory"
          >
            <FileDown className="h-4 w-4" />
            Descargar dossier PDF
          </a>
          <a
            data-testid="contacto-web-btn"
            href={`https://${d.contacto.web}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-ivory/40 px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            Visitar web
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </Chapter>

    <Chapter id="20" num="20" title="Referencias">
      <Body className="text-graphite/55">
        Todas las cifras de mercado citadas en este dossier proceden de las siguientes fuentes:
      </Body>
      <ol className="grid grid-cols-1 gap-x-10 gap-y-3 md:grid-cols-2">
        {d.referencias.map((ref, i) => (
          <li key={i} data-testid={`referencia-${i}`} className="flex items-baseline gap-3 border-b border-sand/60 pb-3 text-sm text-graphite/75">
            <span className="font-mono text-[10px] text-gold">{String(i + 1).padStart(2, "0")}</span>
            {ref}
          </li>
        ))}
      </ol>
    </Chapter>
  </>
);
